<template>
    <div class="share">
        <img class="banner" src="../../../assets/images/share-banner.png" alt="">
        <div class="shareView">
            <div class="titleView">
                <p>最新上架</p>
                <div @click="toPage('/shareList?tab=NEW_ARRIVAL')">
                    <span>更多</span>
                    <Icon name="arrow" />
                </div>
            </div>
            <div class="imageView">
                <div class="imageItemView"
                     v-for="(item, index) in newArrivalList"
                     :key="index" v-if="index < 3"
                     @click="toPage(`/shareDetails/${item.id}`)">
                    <img :src="item.urlPath" alt="">
                    <p>{{item.title}}</p>
                </div>
            </div>
        </div>
        <div class="classView">
            <div class="titleView">
                <p>文案分类</p>
            </div>
            <div class="classBtn">
                <img src="../../../assets/images/ic_treatmentClass1.png" @click="toPage('/shareList?status=POLICY')" alt="">
                <img src="../../../assets/images/ic_treatmentClass2.png" @click="toPage('/shareList?status=HOLIDAYS')" alt="">
                <img src="../../../assets/images/ic_treatmentClass3.png" @click="toPage('/shareList?status=TOPIC')" alt="">
            </div>
        </div>
        <div class="shareView">
            <div class="titleView">
                <p>最高下载</p>
                <div @click="toPage('/shareList?tab=HIGH_DOWNLOADS')">
                    <span>更多</span>
                    <Icon name="arrow" />
                </div>
            </div>
            <div class="imageView">
                <div class="imageItemView"
                     v-for="(item, index) in downloadList"
                     :key="index" v-if="index < 3"
                     @click="toPage(`/shareDetails/${item.id}`)">
                    <img :src="item.urlPath" alt="">
                    <p>{{item.title}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /*
    * 推广中心
    * */
    import {Icon} from 'vant'
    import {getShareList} from "../../../api/share";

    export default {
        name: "Share",
        components: {
            Icon
        },
        data() {
            return {
                newArrivalList: [],
                downloadList: []
            }
        },
        created() {
            getShareList().then(res => {
                this.newArrivalList = res.newArrivalList;
                this.downloadList = res.downloadList;
            })
        }
    }
</script>

<style lang='less' scoped>
    .share {
        min-height: 100vh;
        padding: 2.67vw 3vw;
        background-color: #f8f8f8;
        box-sizing: border-box;
        .titleView {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 11vw;
            padding: 0 3.73vw 0 5.6vw;
            p {
                font-size: 4vw;
                line-height: 2.5vw;
                color: #000000;
                border-bottom: 1.33vw solid #82c1ff;
            }
            div {
                display: flex;
                align-items: center;
                font-size: 3.2vw;
                color: #d2d2d2;
            }
        }
        .banner {
            width: 93.87vw;
            height: 33.6vw;
            margin-bottom: 3.87vw;
            border-radius: 2.67vw;
        }
        .shareView {
            width: 93.87vw;
            background-color: #ffffff;
            box-shadow: 0 0.53vw 1.33vw -0.53vw rgba(0, 0, 0, 0.08);
            border-radius: 2.67vw;
            .imageView {
                display: flex;
                justify-content: space-between;
                padding-top: 0.87vw;
                .imageItemView {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    img {
                        display: block;
                        width: 17.07vw;
                        height: 30.4vw;
                    }
                    p {
                        line-height: 9.87vw;
                        font-size: 3.2vw;
                        color: #333333;
                    }
                }
            }
        }
        .classView  {
            margin-top: 1vw;
            margin-bottom: 4.13vw;
            .classBtn {
                display: flex;
                justify-content: space-between;
                padding: 0 6.93vw;
                img {
                    width: 17.47vw;
                    height: 17.47vw;
                    border-radius: 2.67vw;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/mine/share/Index.vue